const SET_BUTTON_TEXT = 'SET_BUTTON_TEXT';
const SET_RAW_STYLES = 'SET_RAW_STYLES';
const SET_STYLES = 'SET_STYLES';
const SET_RAW_INTENSITY = 'SET_RAW_INTENSITY';
const SET_CURRENT_STYLE = 'SET_CURRENT_STYLE';
const SET_MESSAGES = 'SET_MESSAGES';
const SET_MESSAGE = 'SET_MESSAGE';
const SET_BUTTON_HTML = 'SET_BUTTON_HTML';
const SET_EXPAND_MESSAGES = 'SET_EXPAND_MESSAGES';
const UPDATE_STYLES = 'UPDATE_STYLES';
const UPDATE_RAW_INTENSITY = 'UPDATE_RAW_INTENSITY';
const UPDATE_BUTTON_PROPS = 'UPDATE_BUTTON_PROPS';
const SET_SHOW_SPEAK_BUTTON = 'SET_SHOW_SPEAK_BUTTON';

export {
    SET_BUTTON_TEXT,
    SET_RAW_STYLES,
    SET_STYLES,
    SET_RAW_INTENSITY,
    SET_CURRENT_STYLE,
    SET_MESSAGES,
    SET_MESSAGE,
    SET_BUTTON_HTML,
    SET_EXPAND_MESSAGES,
    SET_SHOW_SPEAK_BUTTON,
    UPDATE_STYLES,
    UPDATE_RAW_INTENSITY,
    UPDATE_BUTTON_PROPS
}


// WEBPACK FOOTER //
// ./src/actions/Actions.js